import { render, staticRenderFns } from "./ConnectionEndOfWorksDate.vue?vue&type=template&id=96724302&scoped=true"
import script from "./ConnectionEndOfWorksDate.vue?vue&type=script&lang=ts"
export * from "./ConnectionEndOfWorksDate.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionEndOfWorksDate.vue?vue&type=style&index=0&id=96724302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96724302",
  null
  
)

export default component.exports